import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { BuildabilityStatus } from '../../entities/BuildabilityStatus'
import { State } from '../../redux/reducers/rootReducer'
import useTranslation from '../../hooks/useTranslation'
import style from './vehicleBuildabilityStatus.css'

export type Props = {
    configurationString: string
}

const VehicleBuildabilityStatus: FunctionComponent<Props> = ({ configurationString }) => {
    const buildabilityStatus = useSelector((state: State) =>
        state.configurationBuildability[configurationString],
    )
    const { t } = useTranslation()

    const getStatusText = (configurationString: string, status?: BuildabilityStatus): string => {
        if (!configurationString) {
            return t('garage.buildabilityStatus.UNKNOWN')
        }

        if (!status) {
            return t('garage.buildabilityStatus.LOADING')
        }

        return t(`garage.buildabilityStatus.${status}`)
    }

    const getDotClass = (configurationString: string, status?: BuildabilityStatus): string => {
        if (!configurationString || status === 'UNKNOWN') {
            return `${style.statusDot} ${style.statusDotUnknown}`
        }

        if (!status) {
            return `${style.statusDot} ${style.statusDotLoading}`
        }

        switch (status) {
            case 'BUILDABLE':
                return `${style.statusDot} ${style.statusDotBuildable}`
            case 'NOT_BUILDABLE':
                return `${style.statusDot} ${style.statusDotNotBuildable}`
            default:
                return `${style.statusDot} ${style.statusDotUnknown}`
        }
    }

    const displayText = getStatusText(configurationString, buildabilityStatus)
    const dotClass = getDotClass(configurationString, buildabilityStatus)

    return (
        <div
            className={style.buildabilityStatus}
            title={configurationString}
            data-testid="buildability-status-container"
        >
            <span className={style.label}>{t('garage.lastConfigurations.status')}</span>
            <div className={dotClass} data-testid={`buildability-status-dot-${buildabilityStatus || 'LOADING'}`}></div>
            <span data-testid="buildability-status-text">{displayText}</span>
        </div>
    )
}

export default VehicleBuildabilityStatus
